import { gql } from "@apollo/client"
import { BenefitsPlanContributionSettingType, Maybe } from "@oysterhr/schema"

export const PLAN_CONTRIBUTION_SETTINGS_FRAGMENT = gql`
  fragment PlanContributionSettingFragment on BenefitsPlan {
    planContributionSetting {
      id
      amount
      percentage
      employerCanCustomize
      minimumPercentage
      maximumPercentage
      minimumAmountSubunit
      maximumAmountSubunit
    }
  }
`

export type PlanContributionSettingFragment = {
  planContributionSetting?: Maybe<
    Pick<
      BenefitsPlanContributionSettingType,
      | "id"
      | "amount"
      | "percentage"
      | "employerCanCustomize"
      | "minimumPercentage"
      | "maximumPercentage"
      | "minimumAmountSubunit"
      | "maximumAmountSubunit"
    >
  >
}
